export const REG_PERIOD = 'regPeriod';
export const ACTIVITY_PERIOD = 'visitPeriod';
export const INACTIVE_SINCE_DATE = 'inactiveSinceDate';
export const USER_LEVEL = 'userLevel';
export const DAYS_OFFLINE = 'daysOffline';
export const SENIORITY_DAYS = 'seniorityDays';
export const RE_COUNTER = 'reCounter';
